import { UrlSegment } from '@angular/router';
import { CollectionHelper } from './collection-helper';

export class RouteHelper {
  private constructor() {}

  static urlSegmentsContain(
    urlSegments: UrlSegment[],
    lookup: string
  ): boolean {
    return (
      CollectionHelper.isPopulated(urlSegments) &&
      urlSegments.some(s => s.path === lookup)
    );
  }
}
